/**
 * Concept lookup helpers used by AiPlan concept multi-select.
 * Slimmed from gri_fe FilterBar utils for aihub-fe.
 */
import {
  type ConceptValue,
  getConceptValues,
} from "../../../services/regulationsService";

/** Fetch concept values and filter to those matching given codes */
export async function fetchConceptsByCodes(
  conceptName: string,
  codes: string[],
): Promise<ConceptValue[]> {
  if (!codes?.length) return [];
  const codeSet = new Set(codes);
  const result: ConceptValue[] = [];
  const response = await getConceptValues(conceptName, undefined, {
    page: 1,
    page_size: 500,
  });
  const items = Array.isArray(response?.data) ? response.data : [];
  if (response?.code === 200) {
    items.forEach((item) => {
      if (codeSet.has(item.code)) result.push(item);
    });
  }
  const missing = codes.filter((c) => !result.some((r) => r.code === c));
  for (const code of missing) {
    try {
      const searchRes = await getConceptValues(conceptName, code, {
        page: 1,
        page_size: 20,
        searchBy: "code",
      });
      const searchItems = Array.isArray(searchRes?.data) ? searchRes.data : [];
      const found = searchItems.find((item) => item.code === code);
      if (found) result.push(found);
    } catch {
      // Skip; caller can fall back to code as label
    }
  }
  return result;
}
